(function (ws) {
    'use strict';

    ws.views.configurator =  ws.views.modal.extend({
        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .close': 'onClose'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg.on('configuratorModal', this.handleParams, this);
            ws.views.modal.prototype.initialize.call(this);
            this.configuratorEndpoint = $('#configuratorEndpoint').val();
        },

        handleParams: function (partNumber, displayEntryNumber, tokenId, salesOrg, endUser, reseller, vendorId, dealId) {
            this.endUserId = endUser;
            this.partNumber = partNumber;
            this.actAs = `${salesOrg}:${reseller}:Account Manager`;
            this.ssoTokenPortal = tokenId;
            this.vendorId = vendorId;
            this.dealId = dealId;
            this.$('#configuratorLineNumber').val(displayEntryNumber);
            this.eventAgg.trigger('configurator');
        },

        /**
         * onOpen override - Reset the modal
         *
         */
        onOpen: function () {
            this.$iframe = this.$('iframe');
            let vendorQuoteId = this.dealId ? encodeURIComponent(this.dealId) : encodeURIComponent($('.vendorQuoteId').text());
            let url = globals.path.configuratorUrl.replace('{configuratorEndpoint}', this.configuratorEndpoint).replace('{endUserId}', this.endUserId).replace('{denodoId}', this.partNumber).replace('{ssoTokenPortal}', this.ssoTokenPortal).replace('{actAs}', this.actAs);
            if ($('#mitelSubscriptionOrder').val() === true || $('#mitelSubscriptionOrder').val() === 'true') {
                url += `&dealId=${vendorQuoteId}&vendor=Mitel`;
            }

            this.$iframe.attr('src', url);
            ws.views.modal.prototype.onOpen.call(this);
        }
    });
})(westcon);
